/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Reason_No_ChannelInputs */

const en_sorx_reason_no_channel = /** @type {(inputs: Sorx_Reason_No_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no channel set up`)
};

const id_sorx_reason_no_channel = /** @type {(inputs: Sorx_Reason_No_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kanal belum diatur`)
};

/**
* | output |
* | --- |
* | "no channel set up" |
*
* @param {Sorx_Reason_No_ChannelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_reason_no_channel = /** @type {((inputs?: Sorx_Reason_No_ChannelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Reason_No_ChannelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_reason_no_channel(inputs)
	return en_sorx_reason_no_channel(inputs)
});